// Shadow tokens, aligned with ui/docs/simkura-design.md.
//
// The new spec uses a level system (level0/1/2). Old names (light, strong,
// underline, superHeavy) are preserved as aliases so existing pages don't
// break, but new code should use the level names.
//
// Default cards in the new design are FLAT (border + canvas-soft page bg
// does the lifting). Shadows are reserved for floating UI: modals,
// dropdowns, toasts.

const LEVEL_1_LIGHT = '0 1px 3px rgba(0,55,112,0.06), 0 0 0 1px rgba(0,55,112,0.02)';
const LEVEL_2_LIGHT = '0 4px 12px rgba(0,55,112,0.08), 0 1px 3px rgba(0,55,112,0.04)';
const LEVEL_3_LIGHT = '0 12px 32px rgba(0,55,112,0.12), 0 4px 12px rgba(0,55,112,0.08)';

export const BOX_SHADOW_LIGHT = {
  // Levels (new — preferred)
  level0:    'none',
  level1:    LEVEL_1_LIGHT,   // subtle lift (popovers)
  level2:    LEVEL_2_LIGHT,   // floating card (dropdowns)
  level3:    LEVEL_3_LIGHT,   // modals

  // Aliases (back-compat with existing pages)
  light:      LEVEL_1_LIGHT,
  strong:     LEVEL_2_LIGHT,
  underline:  '0 1px 0 0 rgba(13, 37, 61, 0.08)',
  superHeavy: LEVEL_3_LIGHT,
};

const LEVEL_1_DARK = '0 1px 3px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.04)';
const LEVEL_2_DARK = '0 4px 12px rgba(0,0,0,0.4), 0 1px 3px rgba(0,0,0,0.2)';
const LEVEL_3_DARK = '0 12px 32px rgba(0,0,0,0.5), 0 4px 12px rgba(0,0,0,0.3)';

export const BOX_SHADOW_DARK = {
  level0:    'none',
  level1:    LEVEL_1_DARK,
  level2:    LEVEL_2_DARK,
  level3:    LEVEL_3_DARK,

  light:      LEVEL_1_DARK,
  strong:     LEVEL_2_DARK,
  underline:  '0 1px 0 0 rgba(0, 0, 0, 0.4)',
  superHeavy: LEVEL_3_DARK,
};
